import { createFileRoute } from "@tanstack/react-router";
import InKindForm from "@project/donate/pages/inkind/index";

export const Route = createFileRoute("/donate/inkind")({
  head: () => ({ meta: [{ title: "In-Kind Donation — Jivandhara" }] }),
  component: InKindForm,
});
